import { fmt$, fmtNum } from "@/lib/calc";

const NEGRO = "#080808";
const PAPEL = "#FAF7F2";
const AMARILLO = "#FFBA35";
const GRIS = "#5a554f";
const GRIS_FUERTE = "#3a352f";
const NEUTRO = "#D8D2C6";
const LINK = "tool.adrianavmarquez.com/calcula-tu-rate";
const CONDENSED = 0.88;

function loadImg(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

function star(ctx, cx, cy, r, color) {
  ctx.save();
  ctx.fillStyle = color;
  ctx.beginPath();
  for (let i = 0; i < 10; i++) {
    const ang = -Math.PI / 2 + (i * Math.PI) / 5;
    const rad = i % 2 ? r * 0.44 : r;
    const x = cx + Math.cos(ang) * rad;
    const y = cy + Math.sin(ang) * rad;
    if (i === 0) ctx.moveTo(x, y);
    else ctx.lineTo(x, y);
  }
  ctx.closePath();
  ctx.fill();
  ctx.restore();
}

// Archivo en el sitio va al 88% de ancho; canvas no soporta font-stretch
function archivo(ctx, text, x, y) {
  ctx.save();
  ctx.translate(x, y);
  ctx.scale(CONDENSED, 1);
  ctx.fillText(text, 0, 0);
  ctx.restore();
}

function archivoWidth(ctx, text) {
  return ctx.measureText(text).width * CONDENSED;
}

async function drawTopBar(ctx, W, barH, lh) {
  ctx.fillStyle = NEGRO;
  ctx.fillRect(0, 0, W, barH);
  try {
    const logo = await loadImg(`${process.env.PUBLIC_URL}/assets/img/logo-adrianavmarquez.png`);
    const lw = (lh * logo.width) / logo.height;
    ctx.drawImage(logo, 48, (barH - lh) / 2, lw, lh);
  } catch {
    ctx.fillStyle = "#fff";
    ctx.font = "800 40px Archivo";
    archivo(ctx, "Creatividad²", 48, barH / 2 + 14);
  }
  ctx.fillStyle = NEUTRO;
  ctx.font = `600 ${Math.round(barH * 0.18)}px Poppins`;
  ctx.textAlign = "right";
  ctx.fillText("CALCULADORA DE TARIFAS", W - 48, barH / 2 + Math.round(barH * 0.07));
  ctx.textAlign = "left";
}

function drawEyebrow(ctx, W, y, starR, fontSize, usuario) {
  star(ctx, 76, y - starR * 0.55, starR, NEGRO);
  ctx.fillStyle = GRIS_FUERTE;
  ctx.font = `700 ${fontSize}px Poppins`;
  ctx.fillText("M I   T A R I F A   D E   C R E A D O R", 108, y);
  if (usuario) {
    ctx.textAlign = "right";
    ctx.fillStyle = NEGRO;
    ctx.fillText(usuario, W - 60, y);
    ctx.textAlign = "left";
  }
}

function drawStats(ctx, W, by, bh, pad, filas, labelSize, valueSize, rowGap) {
  const bx = W > 1080 ? 70 : 60;
  const bw = W - bx * 2;
  ctx.fillStyle = NEGRO;
  ctx.fillRect(bx + 10, by + 10, bw, bh);
  ctx.fillStyle = "#fff";
  ctx.fillRect(bx, by, bw, bh);
  ctx.lineWidth = 4;
  ctx.strokeStyle = NEGRO;
  ctx.strokeRect(bx, by, bw, bh);
  filas.forEach(([l, v], i) => {
    const y = by + rowGap + i * rowGap;
    ctx.fillStyle = GRIS_FUERTE;
    ctx.font = `400 ${labelSize}px Poppins`;
    ctx.fillText(l, bx + pad, y);
    ctx.fillStyle = NEGRO;
    ctx.font = `800 ${valueSize}px Archivo`;
    const vw = archivoWidth(ctx, v);
    archivo(ctx, v, bx + bw - pad - vw, y);
    if (i < filas.length - 1) {
      ctx.strokeStyle = NEUTRO;
      ctx.lineWidth = 3;
      ctx.beginPath();
      ctx.moveTo(bx + pad, y + Math.round(rowGap * 0.32));
      ctx.lineTo(bx + bw - pad, y + Math.round(rowGap * 0.32));
      ctx.stroke();
    }
  });
}

function drawFooter(ctx, W, H, barH, lines) {
  ctx.fillStyle = NEGRO;
  ctx.fillRect(0, H - barH, W, barH);
  star(ctx, 66, H - barH / 2, Math.round(barH * 0.15), AMARILLO);
  lines.forEach(({ text, font, color, dy }) => {
    ctx.fillStyle = color;
    let size = font.size;
    ctx.font = `800 ${size}px Archivo`;
    if (font.condensed !== false) {
      while (archivoWidth(ctx, text) > W - 150 && size > 16) {
        size -= 2;
        ctx.font = `800 ${size}px Archivo`;
      }
      archivo(ctx, text, 100, H - barH / 2 + dy + size * 0.36);
    } else {
      ctx.font = `${font.weight || 600} ${size}px Poppins`;
      ctx.fillText(text, 100, H - barH / 2 + dy + size * 0.36);
    }
  });
}

function buildFilas(r, data) {
  return [
    [`${fmtNum(data.seguidores)} seguidores`, `${r.engagement.toFixed(1)}% engagement`],
    ["Base de tarifa", fmt$(r.base)],
    ["Para la marca valgo (vía CPL)", `~${fmt$(r.leverage)}`],
  ];
}

function drawFeed(ctx, W, H, r, data, usuario) {
  drawEyebrow(ctx, W, 216, 15, 25, usuario);
  ctx.fillStyle = NEGRO;
  ctx.font = "800 54px Archivo";
  archivo(ctx, "Mi piso · lo mínimo que cobro", 60, 296);

  const precio = fmt$(r.tarifa);
  ctx.font = "800 190px Archivo";
  const pw = archivoWidth(ctx, precio);
  ctx.fillStyle = AMARILLO;
  ctx.fillRect(56, 342, pw + 68, 172);
  ctx.fillStyle = NEGRO;
  archivo(ctx, precio, 88, 480);

  ctx.fillStyle = GRIS;
  ctx.font = "400 29px Poppins";
  ctx.fillText("Por crear y postear el video. Si me ofrecen menos, me están robando.", 60, 566);

  drawStats(ctx, W, 612, 250, 42, buildFilas(r, data), 28, 30, 64);

  drawFooter(ctx, W, H, 118, [
    { text: `Calcula la tuya gratis · ${LINK}`, font: { size: 33 }, color: AMARILLO, dy: 0 },
  ]);
}

function drawStory(ctx, W, H, r, data, usuario) {
  drawEyebrow(ctx, W, 300, 18, 30, usuario);
  ctx.fillStyle = NEGRO;
  ctx.font = "800 66px Archivo";
  archivo(ctx, "Mi piso · lo mínimo que cobro", 66, 396);

  const precio = fmt$(r.tarifa);
  ctx.font = "800 240px Archivo";
  const pw = archivoWidth(ctx, precio);
  ctx.fillStyle = AMARILLO;
  ctx.fillRect(66, 452, pw + 84, 216);
  ctx.fillStyle = NEGRO;
  archivo(ctx, precio, 106, 622);

  ctx.fillStyle = GRIS;
  ctx.font = "400 34px Poppins";
  ctx.fillText("Por crear y postear el video.", 66, 742);
  ctx.fillText("Si me ofrecen menos, me están robando.", 66, 794);

  drawStats(ctx, W, 872, 396, 56, buildFilas(r, data), 34, 38, 118);

  star(ctx, W / 2, 1410, 34, AMARILLO);
  ctx.fillStyle = GRIS_FUERTE;
  ctx.font = "700 30px Poppins";
  ctx.textAlign = "center";
  ctx.fillText("TARIFAS CON NÚMEROS, NO CON CORAZONADAS", W / 2, 1485);
  ctx.textAlign = "left";

  drawFooter(ctx, W, H, 190, [
    { text: "Calcula la tuya gratis", font: { size: 44 }, color: AMARILLO, dy: -34 },
    { text: LINK, font: { size: 32 }, color: NEUTRO, dy: 30 },
  ]);
}

export async function generarTarjeta({ r, data, usuario = "", formato = "feed" }) {
  await document.fonts.ready;
  const story = formato === "story";
  const W = 1080;
  const H = story ? 1920 : 1080;
  const cv = document.createElement("canvas");
  cv.width = W;
  cv.height = H;
  const ctx = cv.getContext("2d");

  ctx.fillStyle = PAPEL;
  ctx.fillRect(0, 0, W, H);

  await drawTopBar(ctx, W, story ? 160 : 132, story ? 90 : 74);

  const handle = usuario.trim() ? (usuario.trim().startsWith("@") ? usuario.trim() : `@${usuario.trim()}`) : "";
  if (story) drawStory(ctx, W, H, r, data, handle);
  else drawFeed(ctx, W, H, r, data, handle);

  return new Promise((resolve) => cv.toBlob(resolve, "image/png"));
}
